var _linearGradient, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 20,
    y1: 0,
    y2: 20
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f607ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f4cf5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 20,
    rx: 10,
    width: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.155 11.884v1.794c0 .05-.04.09-.09.09H6.239a.09.09 0 0 1-.059-.158l3.905-3.411a.447.447 0 0 0-.002-.675l-3.9-3.367A.09.09 0 0 1 6.24 6h6.826c.05 0 .09.04.09.09v1.322",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEractive);
export default __webpack_public_path__ + "static/media/er.active.3f8f8612708d818dd1fe417abe6715bd.svg";
export { ForwardRef as ReactComponent };